<fieldset>
    <legend class="fhd-legend">{{ '@criteria' | translate }}</legend>
    <form [formGroup]="scheduleCriteriaForm">
        <div class="flex-container">
            <mat-form-field appearance="fill" class="padded-input">
                <mat-label>{{ '@frequency' | translate }}</mat-label>
                <mat-select formControlName="type">
                    <mat-option *ngFor="let name of CriteriaType | enumToArray" [value]="CriteriaType[name]">
                        {{name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <br />
            <mat-form-field appearance="fill" class="padded-input">
                <mat-label>{{ '@time' | translate }}</mat-label>
                <mat-select formControlName="time">
                    <mat-option *ngFor="let name of TimeCriteria | enumToArray" [value]="TimeCriteria[name]">
                        {{name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <br />
            <mat-form-field appearance="fill" class="padded-input">
                <mat-label>{{ '@distance' | translate }}</mat-label>
                <input matNativeControl type="number" formControlName="distance">
            </mat-form-field>
            <br />
            <mat-form-field appearance="fill" class="padded-input">
                <mat-label>{{ '@engineHours' | translate }}</mat-label>
                <input matNativeControl type="number" formControlName="engineHours">
            </mat-form-field>
            <br />
            <mat-form-field appearance="fill" class="padded-input">
                <mat-label>{{ '@count' | translate }}</mat-label>
                <input matNativeControl type="number" formControlName="count">
            </mat-form-field>
        </div>
        <div class="fhd-border-group">
            <div class="flex-container">
                <h4 class="icon-with-text">
                    {{'@schedulingAttributes' | translate}}
                    <mat-icon title="{{'@scheduleingAttributesTitle' | translate}}">info</mat-icon>
                </h4>
            </div>
            <div class="flex-container">
                <form [formGroup]="scheduleAttributesForm">
                    <ng-container>
                        <mat-chip-listbox class="mat-chip-list-stacked">
                            <mat-chip-option *ngFor="let scheduleAttribute of scheduleAttributes"
                                (removed)="removeScheduleAttribute(scheduleAttribute)">
                                {{scheduleAttribute.key}}: {{scheduleAttribute.value}}
                                <button matChipRemove>
                                    <mat-icon>cancel</mat-icon>
                                </button>
                            </mat-chip-option>
                        </mat-chip-listbox>
                    </ng-container>
                    <mat-form-field class="padded-input grouped">
                        <mat-label>{{ '@property' | translate }}</mat-label>
                        <!-- Type Ahead Search Select -->
                        <input type="text" matInput [formControl]="scheduleAttributeKeysControl"
                            [matAutocomplete]="scheduleAttributeKeysList">
                        <mat-error *ngIf="hasDuplicateKey">
                            {{ '@keyMustBeUnique' | translate }}
                        </mat-error>
                        <mat-autocomplete autoActiveFirstOption #scheduleAttributeKeysList="matAutocomplete">
                            <mat-option *ngFor="let option of scheduleAttributeKeys | async" [value]="option">
                                {{option}}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                    <mat-form-field class="padded-input grouped">
                        <mat-label>{{ '@value' | translate }}</mat-label>
                        <!-- Type Ahead Search Select -->
                        <input type="text" matInput [formControl]="scheduleAttributeValuesControl"
                            [matAutocomplete]="scheduleAttributeValuesList">
                        <mat-autocomplete autoActiveFirstOption #scheduleAttributeValuesList="matAutocomplete">
                            <mat-option *ngFor="let option of scheduleAttributeValueOptions" [value]="option">
                                {{option}}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                    <button mat-mini-fab color="primary" (click)="addScheduleAttribute()"
                        class="fhd-schedule-attribute-form-button">
                        <mat-icon>add</mat-icon>
                    </button>
                    <button mat-mini-fab color="warn" (click)="clearScheduleAttributeForm()"
                        class="fhd-schedule-attribute-form-button">
                        <mat-icon>not_interested</mat-icon>
                    </button>
                </form>
            </div>
        </div>
        <div class="scheduleForm-container-buttons">
            <button mat-raised-button color="primary" (click)="add()" title="{{ '@question' | translate }}"
                class="padded-input">{{ (existingScheduleCriteria ? '@update' : '@add') |
                translate }}</button>
            <button mat-raised-button color="default" (click)="cancel()" class="padded-input">{{ '@cancel'
                | translate
                }}</button>
        </div>
    </form>
</fieldset>